module.exports = __webpack_public_path__ + "img/官网轮播图@2x.97f66fff.png";